// extracted by mini-css-extract-plugin
export var toggleBtnSec = "ToggleButton-module--toggleBtnSec--v60Dz";
export var toggleBtn__refer = "ToggleButton-module--toggleBtn__refer--Q9NaB";
export var toggleBtn__track = "ToggleButton-module--toggleBtn__track--xaCGe";
export var toggleContainer = "ToggleButton-module--toggleContainer--KQG42";